import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { WebToAudioDemoPage } from '@/components/astro/new-design-25/SEO/web-to-audio-demo-page';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute(
  '/_marketing/_seo/listen-to-articles-online',
)({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'Listen to Articles Online — Free Web to Audio Converter with AI Voices | Listening',
        description:
          'Paste any article URL and listen to it with natural AI voices. Works on blogs, news, research papers, and most web pages. Opens a 24-hour read-along link. Free, no sign-up.',
      }),
    ],
    links: [...hreflangLinks('/listen-to-articles-online')],
  }),
  component: WebToAudioDemoPage,
});
